import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  paper: {
    overflow: "hidden",
  },
  dialogTitle: {
    textTransform: "capitalize",
  },
  dialogContent: {
    flex: "1 1 330px",
    overflow: "auto",
    position: "relative",
  },
  input: {
    height: 86,
  },
  loading: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
}));

export default useStyles;
